<template>
    <div class="row">
    <div class="col-sm-12">
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th>Employer</th>
                    <th>ID</th>
                    <th>Agency</th>
                    <th>Account Manager</th>
                    <th>Subscription</th>
                    <th>Budget</th>
                    <th>Total Spend</th>
                    <th v-if="check_budgets">P: {{ formatPercentage(monthlyPercentage) }}</th>
                    <th v-else>Percentage</th>
                    <th>Billable Amount</th>
                    <th>Status</th>
                    <th colspan="2">Next Period Status & Budget</th>
                    <th>Detail</th>
                </tr>
                </thead>
                <tbody v-if="loading">
                    <tr>
                        <td colspan="13" style="text-align: center; padding: 60px; font-size: 1.5em;">
                            <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Loading
                        </td>
                    </tr>
                </tbody>

                <template v-else v-for="s in filteredSections">
                    <tbody>
                    <tr>
                        <th colspan="13"> {{ s.name }}</th>
                    </tr>
                    </tbody>
                    <template v-for="r in s.rows">
                        <tbody>
                        <tr class="period-budget" style="cursor: pointer;" @click="toggleInner(r)">
                            <td>
                                <span v-if="r.is_new_client" class="glyphicon glyphicon-asterisk" style="color: gold" title="New Company"></span>
                                {{ r.name }}
                                <employer-icons :employer="r.employer"></employer-icons>

<!--                                <span class="glyph-close glyphicon is-aligned-right" :class="[r.open ? 'glyphicon-collapse-down' : 'glyphicon-collapse-up']"></span>-->
                            </td>
                            <td>{{ r.employer_id }}</td>
                            <td>{{ r.agency_name }}</td>
                            <td>{{ accountManagerListById[r.account_manager_id] }}</td>
                            <td>{{ r.subscription_type }}</td>
                            <td>
                                {{ formatNumber(r.budget) }}
                                <div v-if="r.addons"><i>+ {{ formatNumber(r.addons) }}</i></div>
                            </td>
                            <td>{{ formatNumber(r.spend) }}</td>
                            <td>
                                <span v-if="check_budgets && r.elapsed_time > 0 && (r.percentege > r.elapsed_time + 0.2 || r.percentage < r.elapsed_time - 0.2)" style="color: red; font-weight: bold;">
                                    {{ formatPercentage(r.percentage) }}
                                </span>
                                <span v-else>
                                    {{ formatPercentage(r.percentage) }}
                                </span>
                            </td>
                            <td>{{ formatNumber(r.billable) }}</td>
                            <td>{{ r.status }}</td>
                            <td>{{ r.next_status }}</td>
                            <td>
                                {{ formatNumber(r.next_period_budget) }}
                            </td>
                            <td><a :href="r.edit_link" @click.stop="">Edit</a></td>
                        </tr>
                        </tbody>
                        <template v-if="r.open">
                            <tbody v-if="!r.rows.length">
                                <tr>
                                    <td colspan="13" style="text-align: center; padding: 40px; font-size: 1.5em;">
                                        <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Loading
                                    </td>
                                </tr>
                            </tbody>
                            <budgets-drilldown-inner v-else :rows="r.rows"></budgets-drilldown-inner>
                        </template>
                    </template>
                </template>
            </table>
        </div>
    </div>
    </div>
</template>

<style>
    .glyphicon-refresh-animate {
        -animation: spin .7s infinite linear;
        -webkit-animation: spin2 .7s infinite linear;
    }

    @-webkit-keyframes spin2 {
        from { -webkit-transform: rotate(0deg);}
        to { -webkit-transform: rotate(360deg);}
    }

    @keyframes spin {
        from { transform: scale(1) rotate(0deg);}
        to { transform: scale(1) rotate(360deg);}
    }
</style>

<script>
    export default {
        props: [
            'month',
            'sort',
            'search',
            'agency',
            'version',
            'check_budgets',
            'salesman',
            'accountManager',
            'accountManagerList',
            'trial',
            'type',
        ],
        data() {
            let monthlyPercentage = moment().diff(moment().startOf('month'), 'hours') / moment().endOf('month').diff(moment().startOf('month'), 'hours');
            return {
                'sections': [],
                'salesmenEmployers': [],
                'accountManagers': [],
                'loading': true,
                'monthlyPercentage': monthlyPercentage,
            };
        },
        mounted() {
            this.init();
        },
        computed: {
            filteredSections() {
                let query = _.lowerCase(this.search);
                return _.map(this.$data.sections, (section) => {
                        return {
                            name: section.name,
                            rows: _.filter(
                                section.rows,
                                (r) => ( !query ||  r.lookup.includes(query))
                                    && (!this.agency || r.agency_name === this.agency)
                                    && (!this.type || (this.type === 'direct' ? r.agency_name === null : r.agency_name !== null))
                                    && (!this.check_budgets || (
                                        r.agency_name !== 'Tenstreet'
                                        && r.budget !== "Unlimited"
                                        && section.name !== 'Stopped advertising last month'
                                        && section.name !== 'Stopped advertising this month'
                                        ))
                                    && (!this.salesman || this.salesmenEmployers[this.salesman].includes(r.employer_id))
                                    && (!this.accountManager || this.accountManagers[this.accountManager].includes(r.employer_id))
                                    && (!this.trial || (this.trial === 'only_trial' && r.employer.trial) || (this.trial === 'no_trials' && !r.employer.trial))
                            )
                        }
                    }
                );
            },
            accountManagerListById() {
                const list = {};
                _.each(this.accountManagerList, (person) => {
                    list[person.id] = person.name;
                });
                return list;
            },
        },
        watch: {
            sort() { this.init(); },
            month() { this.init(); },
            version() { this.init(true); },
        },
        methods: {
            init(force) {
                this.$data.loading = true;
                force = force || '';
                axios.get(url(`/admin/budgets-data`), {
                    params: {
                        'from': this.month.format('DD-MM-YYYY'),
                        'sortBy': this.sort,
                        'force': force,
                        'salesman': this.salesman,
                        'accountManager': this.accountManager
                    }}).then((response) => {
                    this.$data.sections = response.data.sections;
                    this.$data.salesmenEmployers = response.data.salesmenEmployers;
                    this.$data.accountManagers = response.data.accountManagers;
                    this.$data.loading = false;
                });
            },
            formatNumber(number) {
                return (number !== "Unlimited" && number !== "") ? numeral(number).format('$0,0.00') : number;
            },
            formatPercentage(number) {
                if(number === '-') { return number; }
                return (number !== "Unlimited" && number !== "") ? numeral(number).format('0.00%') : number;
            },
            toggleInner(r) {
                // r.open = !r.open;
                // if (!r.rows.length) {
                //     axios.get(`/admin/budgets-data/inner/${r.id}`).then((response) => {
                //         r.rows = response.data;
                //     });
                // }
            }
        }
    }
</script>
